import { forwardRef, useStyleConfig, type BoxProps, type ThemingProps, Box } from "~/foundation/Chakra";

export type ExtendedBoxProps = BoxProps & ThemingProps;

export const ExtendedBox = forwardRef<ExtendedBoxProps, "div">((props, ref) => {
	const { variant, ...rest } = props;
	const styles = useStyleConfig("ExtendedBox", { variant });

	return <Box ref={ref} __css={styles} {...rest} />;
});